import React, { useState } from "react";

const Slider = props => {
  const [data] = useState({
    logo: "/img/taco_bgwhite.png",
    heading: "Presentamos nuestra nueva app!",
    content: "Con nuestra app podrás conocer el precio de miles de artículos desde tu celular.\n Solamente escanea el código de barras del producto y listo!",
    image:    "/img/waves-shape.svg",
    sliderImage: "/img/iphone-x-frame.png",
    actions: [
      {
        link: "#download",
        btnClass: "btn softo-solid-btn page-scroll",
        faClass: "fa fa-android",
        value: "Descargar"
      },
    ],
    phoneImages: [
      { image: "/img/slider/t1.png" },
      { image: "/img/slider/t2.png" },
      { image: "/img/slider/t3.png" },
      { image: "/img/slider/t4.png" },
      { image: "/img/slider/t5.png" },
    ]
  });
    
  return (
    <div>
      <section id="slider" className="section-lg section-hero section-circle">
        
        <div className="shape shape-style-1 shape-primary">
          <span className="circle-150"></span>
          <span className="circle-50"></span>
          <span className="circle-50"></span>
          <span className="circle-75"></span>
          <span className="circle-100"></span>
          <span className="circle-75"></span>
          <span className="circle-50"></span>
          <span className="circle-100"></span>
          <span className="circle-50"></span>
          <span className="circle-100"></span>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="hero-content-wrap">
                <div className="hero-content">
                  <img alt="logo" src={ data.logo } style={ { height: 140 } }/>
                  <h1>{data.heading}</h1>
                  <p>{data.content}</p>
                  <div className="slider-action-btn">
                    {data.actions.map((data, idx) => {
                      return (
                        <a key={`sk_${idx}`} href={data.link} className={data.btnClass}> 
                          <i className={data.faClass}></i> {data.value}
                        </a>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="mobile-slider-area">
                
                <div className="phone">
                  <img src={data.sliderImage} alt="" className="img-responsive"/>
                  <div className="mobile-slider owl-carousel owl-theme">
                    {data.phoneImages.map((item, idx) => {
                      return (
                        <div key={`pi_${idx}`} className="item">
                          <img src={item.image} alt="" className="img-responsive" />
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="slider-indicator">
                  <ul>
                    <li id="prev">
                      <i className="fa fa-angle-left"></i>
                    </li>
                    <li id="next">
                      <i className="fa fa-angle-right"></i>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div className="section-shape">
          <img src={data.image} alt="" />
        </div>

      </section>
    </div>
  );
}

export default Slider;
